import type { ApiRequestParams } from 'utils/request/ApiRequestParams';

export const prolongingTokenEndpoints = [
  '/auth/token',
  '/auth/token/swap',
  '/auth/login',
];

/**
 * Type guard to check if the API request is one that prolongs the refresh token.
 * These requests return an object with `refreshTokenExpiresInSeconds` property.
 * And generate new tokens on each call.
 */
export const isRequestProlongingToken = (
  params: ApiRequestParams,
  result: unknown,
): result is { refreshTokenExpiresInSeconds: number } =>
  params.method === 'POST' && prolongingTokenEndpoints.includes(params.url);
